import React from 'react';
import { FieldRadioButton } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import css from '../EditListingDescriptionForm.css';
import { useIntl } from 'react-intl';
import {
    HORSE_TYPE_FREIZEITPFERD,
    HORSE_TYPE_HORSE_KIND,
    HORSE_TYPE_JUNGPFERD_IN_AUSBILDUNG,
    HORSE_TYPE_SENIOR,
} from '../../../components/EditListingWizard/config';

const EditListingDescriptionPageOne = ({ form }) => {
    const intl = useIntl();

    return (
        <>
            <div>
                <h1 className={css.horseTypeTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.horseTypeTitle" />
                </h1>
                <p className={css.horseTypeSubTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.horseTypeSubTitle" />
                </p>

                <div>
                    {[
                        HORSE_TYPE_JUNGPFERD_IN_AUSBILDUNG,
                        HORSE_TYPE_FREIZEITPFERD,
                        HORSE_TYPE_HORSE_KIND,
                        HORSE_TYPE_SENIOR,
                    ].map(option => (
                        <FieldRadioButton
                            id={option}
                            name="horseType"
                            label={intl.formatMessage({
                                id: `EditListingDescriptionForm.horseType-${option}`,
                            })}
                            form={form}
                            value={option}
                            validate={required(
                                intl.formatMessage({
                                    id: 'EditListingPricingForm.packagePriceRequired',
                                })
                            )}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default EditListingDescriptionPageOne;
